import logo from "@/assets/logo.png";
import heroImg from "@/assets/hero_visual.jpeg";
import loansImg from "@/assets/financial_office.jpg";
import marcusImg from "@/assets/marcus.jpg";
import ceoImg from "@/assets/ceo.jpg";

export { logo, heroImg, loansImg, marcusImg, ceoImg };

export const SECTOR_IMAGES = {
  ag: "https://images.unsplash.com/photo-1627920769842-6887c6df05ca?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  edu: "https://images.unsplash.com/photo-1576495199011-eb94736d05d6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  re: "https://images.unsplash.com/photo-1549791084-5f78368b208b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  ind: "https://images.pexels.com/photos/1624694/pexels-photo-1624694.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  inf: "https://images.unsplash.com/photo-1496055401924-5e7fdc885742?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  aut: "https://images.unsplash.com/photo-1716191299980-a6e8827ba10b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  avi: "https://images.pexels.com/photos/27490332/pexels-photo-27490332.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const SECTORS = [
  { id: "ag", key: "ag", accent: "#10B981", span: "lg:col-span-5", img: SECTOR_IMAGES.ag },
  { id: "edu", key: "edu", accent: "#3B82F6", span: "lg:col-span-4", img: SECTOR_IMAGES.edu },
  { id: "re", key: "re", accent: "#F59E0B", span: "lg:col-span-3", img: SECTOR_IMAGES.re },
  { id: "ind", key: "ind", accent: "#F97316", span: "lg:col-span-4", img: SECTOR_IMAGES.ind },
  { id: "inf", key: "inf", accent: "#8B5CF6", span: "lg:col-span-5", img: SECTOR_IMAGES.inf },
  { id: "aut", key: "aut", accent: "#06B6D4", span: "lg:col-span-3", img: SECTOR_IMAGES.aut },
  { id: "avi", key: "avi", accent: "#EC4899", span: "lg:col-span-12", img: SECTOR_IMAGES.avi },
];

export const TEAM = [
  {
    name: "Dr. Miguel Cardona",
    roleKey: "team.r1",
    img: ceoImg,
    ceo: true,
  },
  {
    name: "Elena Vance",
    roleKey: "team.r2",
    img: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    name: "Marcus Sterling",
    roleKey: "team.r3",
    img: marcusImg,
  },
  {
    name: "Amara Okafor",
    roleKey: "team.r4",
    img: "https://images.pexels.com/photos/13188831/pexels-photo-13188831.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    name: "David Nakamura",
    roleKey: "team.r5",
    img: "https://images.unsplash.com/photo-1718209881007-c0ecdfc00f9d?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    name: "Sofia Marchetti",
    roleKey: "team.r6",
    img: "https://images.unsplash.com/photo-1637589267610-6c66fc2a086b?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
];

export const CONTACT = {
  facebook: "https://www.facebook.com/share/19fV7cjzcB/",
  whatsappNumber: "+16728899844",
  whatsappLink:
    "https://wa.me/16728899844?text=" +
    encodeURIComponent("Hello Pacific Investment Group, I'd like to discuss funding options."),
  email: "info@pacificinvestment.org",
  address: "KW Commercial, 105 Prom. des Lanternes #250, Brossard, Quebec J4Y 0L2, Canada",
  directionsLink:
    "https://www.google.com/maps/search/?api=1&query=" +
    encodeURIComponent("KW Commercial, 105 Prom. des Lanternes #250, Brossard, Quebec J4Y 0L2, Canada"),
};

export const METRICS = [
  { prefix: "$2.5B+", key: "hero.m1" },
  { prefix: "150+", key: "hero.m2" },
  { prefix: "98%", key: "hero.m3" },
  { prefix: "7", key: "hero.m4" },
];
